<template>
  <div class="r_box" v-loading="isLoading">
    <div class="r_cbox">
      <span>班级筛选</span>
      <el-select
        multiple
        collapse-tags
        class="r_select"
        v-model="chooseClass"
        placeholder="全部"
        filterable
        @change="changeClass"
      >
        <el-option
          v-for="item in classArray"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>

    <div class="r_cbox">
      <span>学生姓名</span>
      <el-select
        multiple
        collapse-tags
        class="r_select"
        v-model="uname"
        placeholder="全部"
      >
        <el-option
          v-for="item in userAarray"
          :key="item.userid"
          :label="item.username"
          :value="item.userid"
        >
        </el-option>
      </el-select>
    </div>

    <div class="r_cbox" v-if="(dataJson.state != 5 && dataJson.state != 6)">
      <span>选择阶段</span>
      <el-select
        class="r_select"
        v-model="chap"
        multiple
        collapse-tags
        placeholder="全部"
        @change="changeChap"
      >
        <el-option
          v-for="(item, index) in dyList"
          :key="index"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
    </div>

    <div class="r_cbox">
      <span>任务内容</span>
      <el-select
        class="r_select"
        v-model="task"
        multiple
        collapse-tags
        placeholder="全部"
      >
        <el-option-group
          v-for="(group, index) in dyAarray"
          :key="index"
          :label="group.name"
        >
          <el-option
            v-for="(item, index2) in group.taskList"
            :key="index + '-' + index2"
            :label="item.name"
            :value="group.id + '-' + item.id"
          >
          </el-option>
        </el-option-group>
      </el-select>
    </div>
    <div class="btn_box">
      <el-button class="btn" type="primary" @click="confirmPdf">确定</el-button>
    </div>

    <el-dialog
      :visible.sync="worksDialog"
      :before-close="handleClose"
      class="worksDialogCSSExp"
      :append-to-body="true"
      :fullscreen="true"
    >
      <div slot="title" class="header-title">
        <div style="color: #fff">
          {{
            (dataJson.state == 5 || dataJson.state == 6)
              ? "按任务导出"
              : "自定义导出" + ":" + dataJson.title
          }}
        </div>
      </div>

      <div class="worksDiaCon" ref="reportPdf">
        <div style="margin-bottom: 30px;font-size: 42px;">
          {{ dataJson.title }}
        </div>
        <!-- <div
          v-for="(userP, upi) in pdfUser"
          style="background-color: #fff;border-radius: 8px;margin-top: 10px;"
          :key="upi + 'upi'" 
        >-->
        <!-- <div style="padding: 10px;box-sizing: border-box;">
            <h1>{{ userP.username }}</h1>
          </div> -->

        <div
          v-for="(i, wip) in workList"
            v-if="(chap.length ? chap.indexOf(wip) != -1 : true)"
          :key="i.id"
          class="stageCon"
        >
          <!-- v-if="
              isStage(i.taskList, userP.userid) &&
                (chap.length ? chap.indexOf(wip) != -1 : true)
            " -->
          <div v-if="dataJson.state != 5" class="stageTit">
            第{{ i.id * 1 + 1 }}阶段<span v-if="i.name">:{{ i.name }}</span>
          </div>
          <div
            v-for="k in i.taskList"
            :key="k.task + 'a'"
              v-if="isTask( k)"
              
            style="margin-bottom: 15px"
          >
            <!-- v-if="isTask(k.toolEList, userP.userid, k)" -->

            <div
              style="
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 10px;
                  "
            >
              <div class="taskTitInd">
                <span>任务{{ k.task + 1 }}</span>
                <span>{{ k.taskTit }}</span>
              </div>
              <div></div>
            </div>
            <div v-if="k.taskDetail" class="taskBri">
              <div v-html="k.taskDetail"></div>
            </div>
            <div
              class="WorksCon"
              v-for="(l, lind) in k.toolEList"
              :key="lind + 'l'"
            >
              <div
                v-if="l.content && l.content.length"
                v-for="(imgp, imgIdx) in l.content"
                :key="imgIdx + 'img'"
              >
              
                <div
                  v-for="(userP, upi) in pdfUser"
                  style="background-color: #fff;border-radius: 8px;margin-top: 10px;"
                  :key="upi + 'upi'"
                >
                  <div  v-if="
                    (imgp && imgp[0] && imgp[0].userid == userP.userid) ||
                      imgp.userid == userP.userid
                  ">
                   
                    <div v-if="l.tool[0] == 15">
                      <div style="padding: 10px;box-sizing: border-box;">
                        <h1>{{ userP.username }}</h1>
                      </div>
                      <div class="toolBlk">
                        <img
                          src="../../../assets/icon/thirdToolList/answer.png"
                          alt=""
                        />
                        <div class="toolTit">
                          <div>工具{{ lind + 1 }}：问答工具</div>
                          <div>提问：{{ l.content[0][0].answerTitle }}</div>
                        </div>
                      </div>
                      <div class="answerTxt">
                        回答:{{ l.content[0][0].answer }}
                      </div>
                    </div>
                    <div v-if="l.tool[0] == 52">
                      <div style="padding: 10px;box-sizing: border-box;">
                        <h1>{{ userP.username }}</h1>
                      </div>
                      <div class="toolBlk">
                        <img
                          src="../../../assets/icon/fourthToolList/text.png"
                          alt=""
                        />
                        <div class="toolTit">
                          <div>工具{{ lind + 1 }}：文档工具</div>
                          <div>
                            根据前期的了解与实地调研对于项目的了解，进行思考与讨论提出问题。
                          </div>
                        </div>
                      </div>
                      <div class="answerTxt" v-html="l.content[0].text"></div>
                    </div>
                    <div v-if="l.tool[0] == 16 || l.tool[0] == 50">
                      <div style="padding: 10px;box-sizing: border-box;">
                        <h1>{{ userP.username }}</h1>
                      </div>
                      <div class="toolBlk">
                        <img
                          v-if="l.tool[0] == 16"
                          src="../../../assets/icon/thirdToolList/work.png"
                          alt=""
                        />
                        <img
                          v-if="l.tool[0] == 50"
                          src="../../../assets/icon/thirdToolList/plwork.png"
                          alt=""
                        />

                        <div class="toolTit">
                          <div>
                            工具{{ lind + 1 }}：{{
                              l.tool[0] == 16 ? "作业提交" : "批量上传"
                            }}
                          </div>
                          <div>
                            根据前期的了解与实地调研对于项目的了解，进行思考与讨论提出问题。
                          </div>
                        </div>
                      </div>
                      <div v-for="(i, codex) in l.content" :key="codex + 'co'">
                        <div class="answerTxt" v-html="i.con"></div>
                      </div>
                    </div>
                    <div
                      v-if="l.tool[0] == 7 || l.tool[0] == 1 || l.tool[0] == 3"
                    >
                    <div style="padding: 10px;box-sizing: border-box;">
                        <h1>{{ userP.username }}</h1>
                      </div>
                      <div class="toolBlk">
                        <img
                          v-if="l.tool[0] == 1"
                          src="../../../assets/icon/secondToolList/whiteBoard.png"
                          alt=""
                        />
                        <img
                          v-if="l.tool[0] == 3"
                          src="../../../assets/icon/secondToolList/mindMapping.png"
                          alt=""
                        />
                        <img
                          v-if="l.tool[0] == 7"
                          src="../../../assets/icon/secondToolList/mindNetwork.png"
                          alt=""
                        />

                        <div class="toolTit">
                          <div>
                            工具{{ lind + 1 }}：{{
                              l.tool[0] == 1
                                ? "电子白板"
                                : l.tool[0] == 7
                                ? "思维网格"
                                : "思维导图"
                            }}
                          </div>
                          <div>
                            根据前期的了解与实地调研对于项目的了解，进行思考与讨论提出问题。
                          </div>
                        </div>
                      </div>
                      <img
                        style="max-width: 200px"
                        :src="l.content[0].con"
                        alt=""
                      />
                      <div>{{ l.content[0].con }}</div>
                    </div>
                    <div v-if="l.tool[0] == 48">
                      <div style="padding: 10px;box-sizing: border-box;">
                        <h1>{{ userP.username }}</h1>
                      </div>
                      <div class="toolBlk">
                        <img
                          src="../../../assets/icon/fourthToolList/table.png"
                          alt=""
                        />
                        <div class="toolTit">
                          <div>工具{{ lind + 1 }}：表格</div>
                          <div>
                            根据前期的了解与实地调研对于项目的了解，进行思考与讨论提出问题。
                          </div>
                        </div>
                      </div>
                      <el-form>
                        <div class="cont" v-html="l.content[0].text"></div>
                      </el-form>
                    </div>
                    <div v-if="l.tool[0] == 4">
                      <div style="padding: 10px;box-sizing: border-box;">
                        <h1>{{ userP.username }}</h1>
                      </div>
                      <div class="toolBlk">
                        <img
                          src="../../../assets/icon/thirdToolList/ask.png"
                          alt=""
                        />
                        <div class="toolTit">
                          <div>工具{{ lind + 1 }}：问卷调查</div>
                          <div>标题:{{ l.content[0][0].askJson.askTitle }}</div>
                        </div>
                      </div>

                      <div
                        style="margin-bottom: 5px"
                        v-for="(i, index) in l.content[0][0].askJson.askJson"
                        :key="index"
                      >
                        <div>题目：{{ i.askstitle }}</div>
                        <el-radio-group
                          v-if="!i.type"
                          v-model="l.content[0][0].anwer[index]"
                        >
                          <el-radio
                            v-for="(item2, checkIndex) in i.checkList"
                            :key="checkIndex + 'b'"
                            :label="checkIndex"
                            disabled
                          >
                            {{ item2 }}
                          </el-radio>
                        </el-radio-group>
                        <el-checkbox-group
                          v-model="l.content[0][0].anwer[index]"
                          v-else
                        >
                          <div class="radioBox">
                            <el-checkbox
                              v-for="(item2, checkIndex) in i.checkList"
                              :key="checkIndex + 'c'"
                              :label="checkIndex"
                              disabled
                            >
                              {{ item2 }}
                            </el-checkbox>
                          </div>
                        </el-checkbox-group>
                      </div>
                    </div>
                    <div v-if="l.tool[0] == 45">
                      <div style="padding: 10px;box-sizing: border-box;">
                        <h1>{{ userP.username }}</h1>
                      </div>
                      <div class="toolBlk">
                        <img
                          src="../../../assets/icon/thirdToolList/choose.png"
                          alt=""
                        />
                        <div class="toolTit">
                          <div>工具{{ lind + 1 }}：选择题</div>
                          <div>
                            根据前期的了解与实地调研对于项目的了解，进行思考与讨论提出问题。
                          </div>
                        </div>
                      </div>
                      <div
                        v-for="(i, index) in l.content[0].testJson"
                        :key="index + 'm'"
                      >
                        <div>
                          题目:{{ i.teststitle }}
                          <span
                            v-if="
                              JSON.stringify(l.content[0].radio[index]) ==
                                JSON.stringify(i.answer)
                            "
                            style="color: #868ce4"
                            >回答正确</span
                          >
                          <span v-else style="color: red">回答错误</span>
                        </div>
                        <div
                          v-if="i.type == 1"
                          style="display: flex; flex-direction: column"
                        >
                          <el-radio-group v-model="l.content[0].radio[index]">
                            <div class="radioBox">
                              <el-radio
                                v-for="(item2, checkIndex) in i.checkList"
                                :key="checkIndex + 'b'"
                                :label="checkIndex"
                                disabled
                                :class="[
                                  i.answer == checkIndex
                                    ? 'redioStyle5'
                                    : 'redioStyle2'
                                ]"
                              >
                                <div
                                  v-if="
                                    item2 && item2.imgType && item2.imgType == 1
                                  "
                                >
                                  <div
                                    class="inImg"
                                    @click.stop="previewImg(item2.src)"
                                  >
                                    <img
                                      style="display: block"
                                      :src="item2.src"
                                      alt=""
                                    />
                                  </div>
                                </div>
                                <span v-else v-html="item2"></span>
                              </el-radio>
                            </div>
                          </el-radio-group>
                        </div>
                        <div class="radioBox">
                          <el-checkbox-group
                            v-model="l.content[0].radio[index]"
                            v-if="i.type == '2'"
                          >
                            <div class="radioBox">
                              <el-checkbox
                                v-for="(item2, checkIndex) in i.checkList"
                                :key="checkIndex + 'c'"
                                :label="checkIndex"
                                disabled
                                :class="[
                                  i.answer.includes(checkIndex)
                                    ? 'redioStyle3'
                                    : 'redioStyle4'
                                ]"
                              >
                                <div style="display: flex">
                                  <div
                                    v-if="
                                      item2 &&
                                        item2.imgType &&
                                        item2.imgType == 1
                                    "
                                  >
                                    <div
                                      class="inImg"
                                      @click.stop="previewImg(item2.src)"
                                    >
                                      <img
                                        style="display: block"
                                        :src="item2.src"
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                  <span v-else v-html="item2"></span>
                                </div>
                              </el-checkbox>
                            </div>
                          </el-checkbox-group>
                        </div>
                      </div>
                    </div>
                    <div v-if="l.tool[0] == 41">
                      <div style="padding: 10px;box-sizing: border-box;">
                        <h1>{{ userP.username }}</h1>
                      </div>
                      <div class="toolBlk">
                        <img
                          src="../../../assets/icon/thirdToolList/select.png"
                          alt=""
                        />
                        <div class="toolTit">
                          <div>工具{{ lind + 1 }}：选择匹配</div>
                          <div>
                            根据前期的了解与实地调研对于项目的了解，进行思考与讨论提出问题。
                          </div>
                        </div>
                      </div>
                      <img
                        @click.stop="previewImg(l.selectJson.url)"
                        style="max-width: 200px"
                        :src="l.selectJson.url"
                        alt=""
                      />
                        <div>
                          {{ l.selectJson.url }}
                        </div>
                      <div>
                        <span style="margin-right: 10px">选项:</span
                        ><span
                          style="margin-right: 10px"
                          v-for="(item, itInd) in l.selectJson.select"
                          :key="itInd"
                          >{{ item }}</span
                        >
                      </div>
                      <div style="margin: 10px 0;">
                        <span style="margin-right: 10px">回答:</span>

                        <div
                          style="margin-right: 10px"
                          v-for="(item, itInd) in l.content"
                          :key="itInd"
                        >
                        <div v-if="item.userid == userP.userid">
                          <div v-for="(itemCon,itemConIndex) in item.con" :key="itemConIndex+'itemConIndex'">
                            选项{{ itemConIndex + 1 }}：{{ l.selectJson.select[itemCon] }}
                            <span
                              v-if="
                                l.selectJson.answer[itemConIndex] == item.con[itemConIndex]
                              "
                              style="color: #868ce4"
                              >回答正确</span
                            >
                            <span v-else style="color: red">回答错误</span>
                          </div>

                        </div>
                          
                        </div>

                      </div>

                      <div>
                        <span style="margin-right: 10px">答案:</span>

                        <span
                          style="margin-right: 10px"
                          v-for="(item, itInd) in l.selectJson.answer"
                          :key="itInd"
                          >选项{{ itInd + 1 }}：{{
                            l.selectJson.select[item]
                          }}</span
                        >
                      </div>
                    </div>
                    <div v-if="l.tool[0] == 47">
                      <div style="padding: 10px;box-sizing: border-box;">
                        <h1>{{ userP.username }}</h1>
                      </div>
                      <div class="toolBlk">
                        <img
                          src="../../../assets/icon/fourthToolList/conSentences.png"
                          alt=""
                        />
                        <div class="toolTit">
                          <div>工具{{ lind + 1 }}：排序</div>
                          <div>
                            根据前期的了解与实地调研对于项目的了解，进行思考与讨论提出问题。
                          </div>
                        </div>
                      </div>
                      <div
                        v-for="(i, index) in l.content[0]"
                        :key="index"
                        style="margin-bottom: 10px"
                      >
                        <div
                          style="
                            height: 20px;
                            display: flex;
                            align-items: center;
                            flex-wrap: wrap;
                          "
                        >
                          题目:
                          <div
                            class="sortTool"
                            v-for="(i, index) in i.addSentence"
                            :key="index"
                          >
                            {{ i }}
                          </div>
                          <span
                            v-if="
                              JSON.stringify(i.chooseSenList) ==
                                JSON.stringify(i.addSentence)
                            "
                            style="color: #868ce4"
                            >回答正确</span
                          >
                          <span v-else style="color: red">回答错误</span>
                        </div>
                        <div
                          style="
                            margin: 10px 0;
                            display: flex;
                            align-items: center;
                            flex-wrap: wrap;
                          "
                        >
                          学生回答:
                          <div
                            class="sortTool"
                            v-for="(i, index) in i.chooseSenList"
                            :key="index"
                          >
                            {{ i }}
                          </div>
                        </div>
                        <div>
                          答案:
                          <span style="margin: 0 5px">{{
                            i.addSentence.join(",")
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- </div> -->
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
    </el-dialog>



    <!-- 自定义导出作业pdf弹框 -->
    <!-- <el-dialog
      :visible.sync="worksDialog"
      :before-close="handleClose"
      class="worksDialogCSSExp"
      :append-to-body="true"
      :fullscreen="true"
    >
      <div slot="title" class="header-title">
        <div style="color: #fff">{{dataJson.state == 5 ?"按任务导出" :'自定义导出' + ':' +dataJson.title }}</div>
      </div>

      <div class="worksDiaCon" ref="reportPdf">
        <div style="margin-bottom: 30px;font-size: 42px;">
          {{ dataJson.title }}
        </div>
        <div
          v-for="(userP, upi) in pdfUser"
          style="background-color: #fff;border-radius: 8px;margin-top: 10px;"
          :key="upi + 'upi'"
        >
          <div style="padding: 10px;box-sizing: border-box;">
            <h1>{{ userP.username }}</h1>
          </div>

          <div
            v-for="(i, wip) in workList"
            v-if="
              isStage(i.taskList, userP.userid) &&
                (chap.length ? chap.indexOf(wip) != -1 : true)
            "
            :key="i.id"
            class="stageCon"
          >
            <div v-if="dataJson.state != 5" class="stageTit">
              第{{ i.id * 1 + 1 }}阶段<span v-if="i.name">:{{ i.name }}</span>
            </div>
            <div
              v-for="k in i.taskList"
              :key="k.task + 'a'"
              v-if="isTask(k.toolEList, userP.userid, k)"
              style="margin-bottom: 15px"
            >
              <div
                style="
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 10px;
                  "
              >
                <div class="taskTitInd">
                  <span>任务{{ k.task + 1 }}</span>
                  <span>{{ k.taskTit }}</span>
                </div>
                <div></div>
              </div>
              <div v-if="k.taskDetail" class="taskBri">
                <div v-html="k.taskDetail"></div>
              </div>
              <div
                class="WorksCon"
                v-for="(l, lind) in k.toolEList"
                :key="lind + 'l'"
              >
                <div
                  v-if="l.content && l.content.length"
                  v-for="(imgp, imgIdx) in l.content"
                  :key="imgIdx + 'img'"
                >
                  <div
                    v-if="
                      (imgp && imgp[0] && imgp[0].userid == userP.userid) ||
                        imgp.userid == userP.userid
                    "
                  >
                    <div v-if="l.tool[0] == 15">
                      <div class="toolBlk">
                        <img
                          src="../../../assets/icon/thirdToolList/answer.png"
                          alt=""
                        />
                        <div class="toolTit">
                          <div>工具{{ lind + 1 }}：问答工具</div>
                          <div>提问：{{ l.content[0][0].answerTitle }}</div>
                        </div>
                      </div>
                      <div class="answerTxt">
                        回答:{{ l.content[0][0].answer }}
                      </div>
                    </div>
                    <div v-if="l.tool[0] == 52">
                      <div class="toolBlk">
                        <img
                          src="../../../assets/icon/fourthToolList/text.png"
                          alt=""
                        />
                        <div class="toolTit">
                          <div>工具{{ lind + 1 }}：文档工具</div>
                          <div>
                            根据前期的了解与实地调研对于项目的了解，进行思考与讨论提出问题。
                          </div>
                        </div>
                      </div>
                      <div class="answerTxt" v-html="l.content[0].text"></div>
                    </div>
                    <div v-if="l.tool[0] == 16 || l.tool[0] == 50">
                      <div class="toolBlk">
                        <img
                          v-if="l.tool[0] == 16"
                          src="../../../assets/icon/thirdToolList/work.png"
                          alt=""
                        />
                        <img
                          v-if="l.tool[0] == 50"
                          src="../../../assets/icon/thirdToolList/plwork.png"
                          alt=""
                        />

                        <div class="toolTit">
                          <div>
                            工具{{ lind + 1 }}：{{
                              l.tool[0] == 16 ? "作业提交" : "批量上传"
                            }}
                          </div>
                          <div>
                            根据前期的了解与实地调研对于项目的了解，进行思考与讨论提出问题。
                          </div>
                        </div>
                      </div>
                      <div v-for="(i, codex) in l.content" :key="codex + 'co'">
                        <div class="answerTxt" v-html="i.con"></div>
                      </div>
                    </div>
                    <div
                      v-if="l.tool[0] == 7 || l.tool[0] == 1 || l.tool[0] == 3"
                    >
                      <div class="toolBlk">
                        <img
                          v-if="l.tool[0] == 1"
                          src="../../../assets/icon/secondToolList/whiteBoard.png"
                          alt=""
                        />
                        <img
                          v-if="l.tool[0] == 3"
                          src="../../../assets/icon/secondToolList/mindMapping.png"
                          alt=""
                        />
                        <img
                          v-if="l.tool[0] == 7"
                          src="../../../assets/icon/secondToolList/mindNetwork.png"
                          alt=""
                        />

                        <div class="toolTit">
                          <div>
                            工具{{ lind + 1 }}：{{
                              l.tool[0] == 1
                                ? "电子白板"
                                : l.tool[0] == 7
                                ? "思维网格"
                                : "思维导图"
                            }}
                          </div>
                          <div>
                            根据前期的了解与实地调研对于项目的了解，进行思考与讨论提出问题。
                          </div>
                        </div>
                      </div>
                      <img
                        style="max-width: 200px"
                        :src="l.content[0].con"
                        alt=""
                      />
                      <div>{{ l.content[0].con }}</div>
                    </div>
                    <div v-if="l.tool[0] == 48">
                      <div class="toolBlk">
                        <img
                          src="../../../assets/icon/fourthToolList/table.png"
                          alt=""
                        />
                        <div class="toolTit">
                          <div>工具{{ lind + 1 }}：表格</div>
                          <div>
                            根据前期的了解与实地调研对于项目的了解，进行思考与讨论提出问题。
                          </div>
                        </div>
                      </div>
                      <el-form>
                        <div class="cont" v-html="l.content[0].text"></div>
                      </el-form>
                    </div>
                    <div v-if="l.tool[0] == 4">
                      <div class="toolBlk">
                        <img
                          src="../../../assets/icon/thirdToolList/ask.png"
                          alt=""
                        />
                        <div class="toolTit">
                          <div>工具{{ lind + 1 }}：问卷调查</div>
                          <div>标题:{{ l.content[0][0].askJson.askTitle }}</div>
                        </div>
                      </div>

                      <div
                        style="margin-bottom: 5px"
                        v-for="(i, index) in l.content[0][0].askJson.askJson"
                        :key="index"
                      >
                        <div>题目：{{ i.askstitle }}</div>
                        <el-radio-group
                          v-if="!i.type"
                          v-model="l.content[0][0].anwer[index]"
                        >
                          <el-radio
                            v-for="(item2, checkIndex) in i.checkList"
                            :key="checkIndex + 'b'"
                            :label="checkIndex"
                            disabled
                          >
                            {{ item2 }}
                          </el-radio>
                        </el-radio-group>
                        <el-checkbox-group
                          v-model="l.content[0][0].anwer[index]"
                          v-else
                        >
                          <div class="radioBox">
                            <el-checkbox
                              v-for="(item2, checkIndex) in i.checkList"
                              :key="checkIndex + 'c'"
                              :label="checkIndex"
                              disabled
                            >
                              {{ item2 }}
                            </el-checkbox>
                          </div>
                        </el-checkbox-group>
                      </div>
                    </div>
                    <div v-if="l.tool[0] == 45">
                      <div class="toolBlk">
                        <img
                          src="../../../assets/icon/thirdToolList/choose.png"
                          alt=""
                        />
                        <div class="toolTit">
                          <div>工具{{ lind + 1 }}：选择题</div>
                          <div>
                            根据前期的了解与实地调研对于项目的了解，进行思考与讨论提出问题。
                          </div>
                        </div>
                      </div>
                      <div
                        v-for="(i, index) in l.content[0].testJson"
                        :key="index + 'm'"
                      >
                        <div>题目:{{ i.teststitle }}</div>
                        <div
                          v-if="i.type == 1"
                          style="display: flex; flex-direction: column"
                        >
                          <el-radio-group v-model="l.content[0].radio[index]">
                            <div class="radioBox">
                              <el-radio
                                v-for="(item2, checkIndex) in i.checkList"
                                :key="checkIndex + 'b'"
                                :label="checkIndex"
                                disabled
                                :class="[
                                  i.answer == checkIndex
                                    ? 'redioStyle5'
                                    : 'redioStyle2'
                                ]"
                              >
                                <div
                                  v-if="
                                    item2 && item2.imgType && item2.imgType == 1
                                  "
                                >
                                  <div
                                    class="inImg"
                                    @click.stop="previewImg(item2.src)"
                                  >
                                    <img
                                      style="display: block"
                                      :src="item2.src"
                                      alt=""
                                    />
                                  </div>
                                  <span>{{ item2.src }}</span>
                                </div>
                                <span v-else v-html="item2"></span>
                              </el-radio>
                            </div>
                          </el-radio-group>
                        </div>
                        <div class="radioBox">
                          <el-checkbox-group
                            v-model="l.content[0].radio[index]"
                            v-if="i.type == '2'"
                          >
                            <div class="radioBox">
                              <el-checkbox
                                v-for="(item2, checkIndex) in i.checkList"
                                :key="checkIndex + 'c'"
                                :label="checkIndex"
                                disabled
                                :class="[
                                  i.answer.includes(checkIndex)
                                    ? 'redioStyle3'
                                    : 'redioStyle4'
                                ]"
                              >
                                <div style="display: flex">
                                  <div
                                    v-if="
                                      item2 &&
                                        item2.imgType &&
                                        item2.imgType == 1
                                    "
                                  >
                                    <div
                                      class="inImg"
                                      @click.stop="previewImg(item2.src)"
                                    >
                                      <img
                                        style="display: block"
                                        :src="item2.src"
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                  <span v-else v-html="item2"></span>
                                </div>
                              </el-checkbox>
                            </div>
                          </el-checkbox-group>
                        </div>
                      </div>
                    </div>
                    <div v-if="l.tool[0] == 41">
                      <div class="toolBlk">
                        <img
                          src="../../../assets/icon/thirdToolList/select.png"
                          alt=""
                        />
                        <div class="toolTit">
                          <div>工具{{ lind + 1 }}：选择匹配</div>
                          <div>
                            根据前期的了解与实地调研对于项目的了解，进行思考与讨论提出问题。
                          </div>
                        </div>
                      </div>
                      <img
                        style="max-width: 200px"
                        :src="l.selectJson.url"
                        alt=""
                      />
                      <div>
                        {{ l.selectJson.url }}
                      </div>
                      <div>
                        <span style="margin-right: 10px">选项:</span
                        ><span
                          style="margin-right: 10px"
                          v-for="(item, itInd) in l.selectJson.select"
                          :key="itInd"
                          >{{ item }}</span
                        >
                      </div>
                      <div>
                        <span style="margin-right: 10px">答案:</span>

                        <span
                          style="margin-right: 10px"
                          v-for="(item, itInd) in l.content[0].con"
                          :key="itInd"
                          >{{ itInd + 1 }}、{{
                            l.selectJson.select[item]
                          }}</span
                        >
                      </div>
                    </div>
                    <div v-if="l.tool[0] == 47">
                      <div class="toolBlk">
                        <img
                          src="../../../assets/icon/fourthToolList/conSentences.png"
                          alt=""
                        />
                        <div class="toolTit">
                          <div>工具{{ lind + 1 }}：排序</div>
                          <div>
                            根据前期的了解与实地调研对于项目的了解，进行思考与讨论提出问题。
                          </div>
                        </div>
                      </div>
                      <div
                        v-for="(i, index) in l.content[0]"
                        :key="index"
                        style="margin-bottom: 10px"
                      >
                        <div
                          style="
                            height: 20px;
                            display: flex;
                            align-items: center;
                            flex-wrap: wrap;
                          "
                        >
                          题目:
                          <div
                            class="sortTool"
                            v-for="(i, index) in i.addSentence"
                            :key="index"
                          >
                            {{ i }}
                          </div>
                          <span
                            v-if="
                              JSON.stringify(i.chooseSenList) ==
                                JSON.stringify(i.addSentence)
                            "
                            style="color: #868ce4"
                            >回答正确</span
                          >
                          <span v-else style="color: red">回答错误</span>
                        </div>
                        <div
                          style="
                            margin: 10px 0;
                            display: flex;
                            align-items: center;
                            flex-wrap: wrap;
                          "
                        >
                          学生回答:
                          <div
                            class="sortTool"
                            v-for="(i, index) in i.chooseSenList"
                            :key="index"
                          >
                            {{ i }}
                          </div>
                        </div>
                        <div>
                          正确答案:
                          <span style="margin: 0 5px">{{
                            i.addSentence.join(",")
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import jspdf from "jspdf";
export default {
  props: ["cid", "dataJson", "classArray"],
  data() {
    return {
      worksDialog: false,
      pdfUser: [],
      uname: [],
      chooseClass: [],
      chap: [],
      task: [],
      dyAarray: [],
      dyList: [],
      userAarray: [], //作业提交学生
      userAarrayCopy: [], //班级筛选的时候使用作业提交学生
      isLoading: false,
      workList: [],
      workEvaList: []
    };
  },
  watch: {
    cid(newValue, oldValue) {
      this.uname = [];
      this.chap = [];
      this.task = [];
      this.getCourseDetail();
    }
  },
  computed: {
    isStage() {
      return function(val) {
        let isShow = false;

        val.forEach(e => {
          e.toolEList.forEach(i => {
            if (i.content.length) {
              isShow = true;
            }
          });
        });

        return isShow;
      };
    },
    isTask() {
      return function(tas) {
        let isShow = false;

        let ap = `${tas.stage}-${tas.task}`;

        if (this.task.length) {
          let arr = this.task.filter(e => {
            return e.indexOf(ap) != -1;
          });

          if (arr.length > 0) {
            isShow = true;
          } else {
            isShow = false;
          }
        }else{
          isShow = true;
        }

        return isShow;
      };
    }
  },
  mounted() {
    this.getCourseDetail();
  },
  methods: {
    // 下载pdf文件
    getPdf() {
      const content = this.$refs.reportPdf;
      const dpi = 300;

      html2canvas(content, {
        dpi: dpi, // 设置截图的分辨率
        scale: dpi / 96 // 设置截图缩放比例，以适应pdf的dpi
      }).then(canvas =>  {
        var contentWidth = canvas.width;
        var contentHeight = canvas.height;

        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        var imgWidth = 595.28;
        var imgHeight = (592.28 / contentWidth) * contentHeight;

        var pageData = canvas.toDataURL("image/jpeg", 1.0);

        var pdf = new jspdf("", "pt", [imgWidth, imgHeight]);

        pdf.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);


        let className = "";

        if (this.chooseClass.length) {
          this.classArray.forEach((e,i)=>{
            if (this.chooseClass.indexOf(e.id) != -1) {
              className += `${e.name}、`
            }
          })
        }else{
          this.classArray.forEach(e=>{
              className += `${e.name}、`
          })
        }

        className = className.slice(0 , -1 ) + '-'

        



        let taskName = "";
        let taskList = JSON.parse(JSON.stringify(this.task));

        // this.pdfUser.forEach((e, i) => {
        //   if (this.pdfUser.length - 1 == i) {
        //     username += `${e.username}-`;
        //   } else {
        //     username += `${e.username},`;
        //   }
        // });

        if (this.dataJson.state == 5) {
          if (!taskList.length) {
            this.dyAarray[0].taskList.forEach(e => {
              let ar = 0 + "-" + e.id;

              taskList.push(ar);
            });
          }

          this.dyAarray[0].taskList.forEach(e => {
            let ar = 0 + "-" + e.id;
            console.log("ar", ar);

            if (taskList.indexOf(ar) != -1) {
              taskName += `${e.name}、`;
            }
          });
          taskName = taskName.slice(0 , -1 )

          pdf.save(className + this.dataJson.title + "-" + taskName + ".pdf");
        } else {
          pdf.save(className + this.dataJson.title + ".pdf");
        }

        // this.worksDialog = false;
      });
    },
    getCourseDetail() {
      this.isLoading = true;
      let params = {
        cid: this.cid
      };
      this.ajax
        .get(this.$store.state.api + "getCourseWorksReport1", params)
        .then(res => {
          // res.data[1];
          // res.data[3]; //问卷
          // res.data[4]; //问答题
          // res.data[5];
          // res.data[6]; //选择题
          // res.data[7]; //个人评价作业
          // res.data[8]; //选择匹配作业
          // res.data[9]; //排序作业
          // res.data[10]; //表格作业
          // res.data[11]; //cocopi或源码编辑作业
          // res.data[12]; //文档作业
          // this.workEvaList = res.data[13]; 
          this.userAarrayCopy = JSON.parse(JSON.stringify(res.data[14]));
          this.userAarray = res.data[14];

          var dyJSON = JSON.parse(res.data[0][0].chapters);
          let dyList = [];
          for (var i = 0; i < dyJSON.length; i++) {
            dyList.push({ name: dyJSON[i].dyName, id: i, taskList: [] });
            var a = dyJSON[i].chapterInfo[0].taskJson;
            for (var j = 0; j < a.length; j++) {
              dyList[i].taskList.push({ name: a[j].task, id: j });
            }
          }
          this.dyList = dyList;
          if (this.dataJson.state == 5 && this.dyList && this.dyList.length) {
            this.chap = [0];
            this.dyAarray.push(dyList[0]);
          }
          // console.log(" this.dyList", this.dyList);

          let framework = [];
          if (res.data[0].length) {
            let elistData = JSON.parse(res.data[0][0].chapters);
            console.log("elistData", JSON.parse(JSON.stringify(elistData)));

            elistData.forEach((e, i) => {
              framework[i] = {
                id: i,
                name: e.dyName ? e.dyName : "",
                taskList: []
              };
              e.chapterInfo[0].taskJson.forEach((k, kin) => {
                // if (k.eList && k.eList.length) {
                //   k.toolChoose.forEach(y => {
                //     y.eList = k.eList;
                //   });
                // }
                framework[i].taskList.push({
                  stage: i,
                  task: kin,
                  taskTit: k.task ? k.task : "",
                  taskDetail: k.taskDetail,
                  toolEList: k.toolChoose
                });
              });
            });
          }

          res.data[3].forEach(e => {
            e.content = JSON.parse(e.content);
          });
          res.data[4].forEach(e => {
            e.content = JSON.parse(e.content);
          });

          res.data[6].forEach((k, i) => {
            const element1 = JSON.parse(k.content)[0];

            let t = JSON.parse(k.content)[0].testJson;

            // 处理学生选择答案
            let e = [];
            t.testJson.forEach((i, y) => {
              e.push(element1.anwer[y]);
            });
            t.radio = e;

            // 处理选项

            k.content = t;
          });
          res.data[8].forEach((k, i) => {
            k.content = k.content.split(",");
          });
          res.data[9].forEach(e => {
            e.content = JSON.parse(e.content);
          });

          res.data[12].forEach(e => {
            e.content = JSON.parse(e.content);
          });
          res.data[10].forEach(e => {
            e.content = JSON.parse(e.content);
          });

          let AreaAllWork = [
            ...res.data[1],
            ...res.data[3],
            ...res.data[4],
            ...res.data[5],
            ...res.data[6],
            ...res.data[7],
            ...res.data[8],
            ...res.data[9],
            ...res.data[10],
            ...res.data[11],
            ...res.data[12]
          ];

          AreaAllWork.sort(function(a, b) {
            return a.stage - b.stage; //从小到大排序
          });
          console.log("AreaAllWork", JSON.parse(JSON.stringify(AreaAllWork)));

          framework.forEach(e => {
            e.taskList.forEach((k, kin) => {
              k.toolEList.forEach((l, lIndex) => {
                l.content = [];
                l.rate = "";
                l.time = "";
                AreaAllWork.forEach((i, index) => {
                  i.tool = i.tool ? i.tool : 0;

                  if (
                    k.stage == i.stage &&
                    k.task == i.task &&
                    lIndex == i.tool
                  ) {
                    if (i.content instanceof Array) {
                      if (i.type == 7) {
                        i.content = { con: i.content, userid: i.userid };
                      } else {
                        i.content[0].userid = i.userid;
                      }
                    } else if (typeof i.content == "string") {
                      i.content = { con: i.content, userid: i.userid };
                    } else {
                      i.content.userid = i.userid;
                    }
                    l.content.push(i.content);
                    l.time = i.tTime;
                  }
                });
              });
            });
          });

          console.log("framework", JSON.parse(JSON.stringify(framework)));

          this.workList = framework;
          this.isLoading = false;
        })
        .catch(err => {
          console.error(err);
        });
    },
    confirmPdf() {
      if (this.uname.length > 0) {
        this.pdfUser = this.userAarray.filter(e => {
          return this.uname.indexOf(e.userid) != -1;
        });
      } else {
        this.pdfUser = this.userAarray;
      }
      console.log("this.pdfUser", this.pdfUser);

      this.worksDialog = true;
      setTimeout(() => {
        this.getPdf();
      }, 500);
    },
    changeChap() {
      let _dyList = this.dyList;
      this.dyAarray = [];
      this.task = [];
      for (var i = 0; i < _dyList.length; i++) {
        if (this.chap.indexOf(_dyList[i].id) != -1) {
          this.dyAarray.push(_dyList[i]);
        }
      }
    },
    changeClass() {
      if (this.chooseClass.length) {
        this.userAarray = this.userAarrayCopy.filter(e => {
          let kk = this.chooseClass.filter(item => e.classid.includes(item));
          return kk.length ? e :''
        });
      } else {
        this.userAarray = JSON.parse(JSON.stringify(this.userAarrayCopy));
      }
    },
    handleClose(done) {
      done();
    }
  }
};
</script>

<style scoped>
/* .r_box {
} */
.r_cbox {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.r_cbox span {
  margin-right: 20px;
}

.r_box .r_select {
  width: 400px;
}

.btn_box {
  margin: 40px 0 0 0;
  width: 100%;
  display: flex;
  justify-content: center;
}
.btn_box .btn {
  width: 60%;
  background: rgb(14, 114, 230);
}
.worksDialogCSSExp >>> .el-dialog__header {
  /* padding: 9px 20px 10px; */
  background: #32455b !important;
}

.worksDialogCSSExp >>> .el-dialog__wrapper {
  overflow: hidden !important;
}
.worksDialogCSSExp >>> .el-dialog__body {
  padding: 0 !important;
  background-color: #f3f7fd;
  height: calc(100% - 50px);
  overflow: auto;
  margin: auto;
}
.worksDialogCSSExp >>> .el-dialog.is-fullscreen {
  overflow: hidden;
}
.worksDiaCon {
  width: 220mm;
  margin: auto;
  min-height: 1200px;
  padding: 60px 5%;
  box-sizing: border-box;
  background-color: rgb(255, 251, 220);
}
.stageCon {
  background-color: #fff;
  padding: 15px;
  box-sizing: border-box;
  margin-bottom: 10px;
  border-radius: 8px;
  width: 100%;
}
.stageTit {
  text-align: left;
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 20px;
  color: rgba(242, 161, 75, 1);
  border-left: 5px rgba(242, 161, 75, 1) solid;
  padding-left: 5px;
}
.taskTitInd {
  font-size: 14px;
}
.TitBti {
  background-color: rgba(242, 161, 75, 1);
  color: #fff;
  padding: 3px 5px;
  border-radius: 4px;
  margin-right: 5px;
  box-sizing: border-box;
  font-size: 12px;
  height: 22px;
  line-height: 16px;
  text-align: center;
}
.taskTitInd span:nth-child(2) {
  color: rgba(0, 0, 0, 0.9);
  font-weight: 600;
}
.taskBri {
  width: 100%;
  background-color: rgba(253, 247, 243, 1);
  padding: 10px 12px;
  line-height: 20px;
  box-sizing: border-box;
  font-weight: PingFang SC;
  font-size: 12px;
  font-weight: 400;
  border-radius: 4px;
}
.toolBlk {
  display: flex;
  height: 44px;
  box-sizing: border-box;
  margin: 0 0 15px 0;
}
.toolBlk img {
  height: 100%;
  margin-right: 8px;
}
.toolTit {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.toolTit div:nth-child(1) {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  color: rgba(0, 0, 0, 0.9);
  margin-right: 10px;
}
.toolTit div:nth-child(2) {
  font-family: PingFang SC;
  font-size: 10px;
  font-weight: 400;
  text-align: left;
  color: rgba(0, 0, 0, 0.9);
}
.txt {
  width: 100%;
  border-bottom: 1px solid rgba(192, 210, 229, 1);
  text-align: center;
  color: #000;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.coverPageCon {
  background-color: #e3edfe;
  display: flex;
  flex-direction: column;
  padding: 0 110px;
  padding-bottom: 30px;
  box-sizing: border-box;
  font-family: PingFang SC;
}
.stageCon {
  background-color: #fff;
  padding: 15px;
  box-sizing: border-box;
  margin-bottom: 10px;
  border-radius: 8px;
  width: 100%;
}

.a_addBox {
  margin: 10px 0;
  background: #fff;
  padding: 0 15px;
  /* max-height: 400px; */
  /* max-height: 160px; */
  /* overflow: auto; */
}
.redioStyle >>> .el-radio__label {
  font-size: 18px;
}

.redioStyle5 >>> .el-radio__label {
  font-size: 14px;
  color: #06a7ff !important;
}
.redioStyle2 >>> .el-radio__label {
  font-size: 14px;
}

.redioStyle3 >>> .el-checkbox__label {
  font-size: 14px;
  color: #06a7ff !important;
}
.redioStyle4 >>> .el-checkbox__label {
  font-size: 14px;
}
.WorksCon >>> .el-checkbox-group {
  margin: 0 5px;
}
.sortTool {
  padding: 1px 3px;
  border: 2px #5d89c4 solid;
  margin: 0 5px;
  min-width: 20px;
  border-radius: 5px;
  text-align: center;
}
/* table 样式 */
.cont >>> table {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}

.cont >>> table td,
.cont >>> table th {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 15px 5px;
  max-width: 0px;
}

.cont >>> table th {
  border-bottom: 2px solid #ccc;
  text-align: center;
}
.taskSco {
  background-color: rgba(243, 247, 253, 1);
  border-radius: 8px;
  padding: 8px;
  box-sizing: border-box;
  margin: 8px 0;
}
.score_boxTit > span {
  border-left: 3px solid rgba(54, 129, 252, 1);
  padding-left: 5px;
}
.score_boxTit {
  /* padding: 0 30px; */
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.9);
}
.inImg {
  width: 100px;
}
.inImg > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.radioBox {
  display: flex;
  flex-direction: column;
}
.WorksCon >>> .el-radio {
  display: flex;
  align-items: center;
  margin: 5px;
}
.WorksCon >>> .el-checkbox {
  display: flex;
  align-items: center;
  margin: 5px;
}
.RootImgBlock {
  width: 50%;
  white-space: wrap;
  /* overflow: hidden;
  text-overflow: ellipsis; */

  font-size: 12px;
}
.score_box {
  display: flex;
  align-items: center;
  font-size: 14px !important;
  /* justify-content: flex-start; */
  justify-content: space-between;
  margin-bottom: 15px;
  /* margin: 10px 0 0 30px; */
  width: 100%;
  margin: 5px 0;
  position: relative;
}
.score_box:last-child {
  margin-bottom: 0;
}
.worksTarget {
  border-left: 3px solid rgba(54, 129, 252, 1);
  font-size: 14px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.9);
}
.worksTarget > span {
  margin-left: 5px;
}
.worksTargetCon {
  background-color: #fff;
  padding: 10px;
  margin-top: 10px;
  border-radius: 8px;
  box-sizing: border-box;
  font-size: 12px;
}
.worksTargetCon > div {
  margin-bottom: 10px;
}
.worksTargetCon > div:last-child {
  margin: 0 !important;
}
.dialog_diy >>> .el-dialog__header {
  padding: 9px 20px 10px;
  background: #32455b !important;
}
.worksDialogCSS >>> .el-dialog__header {
  /* padding: 9px 20px 10px; */
  background: #32455b !important;
}

.worksDialogCSS >>> .el-dialog__body {
  width: 643px !important;
}
.worksDialogCSS >>> .el-dialog {
  width: 683px !important;
}
.stageTit {
  text-align: left;
  font-weight: 600;
  font-size: 22px;
  margin-bottom: 20px;
  color: rgba(242, 161, 75, 1);
  border-left: 5px rgba(242, 161, 75, 1) solid;
  padding-left: 5px;
}
.taskTitInd {
  font-size: 14px;
  display: flex;
  align-items: center;
}
.taskTitInd span:nth-child(1) {
  background-color: rgba(242, 161, 75, 1);
  color: #fff;
  padding: 3px 5px;
  border-radius: 4px;
  margin-right: 5px;
  box-sizing: border-box;
  font-size: 12px;
}
.taskTitInd div {
  background-color: rgba(242, 161, 75, 1);
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-right: 10px;
}
.taskTitInd span:nth-child(2) {
  color: rgba(0, 0, 0, 0.9);
  font-weight: 600;
}
.taskBri {
  background-color: rgba(253, 247, 243, 1);
  padding: 10px 12px;
  line-height: 20px;
  box-sizing: border-box;
  font-weight: PingFang SC;
  font-size: 12px;
  font-weight: 400;
  border-radius: 4px;
}
.toolBlk {
  display: flex;
  height: 44px;
  margin: 15px 0;
}
.toolBlk img {
  height: 100%;
  margin-right: 8px;
  background-color: #FFFBDC;
}
.toolTit {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.toolTit div:nth-child(1) {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  color: rgba(0, 0, 0, 0.9);
  margin-right: 10px;
}
.toolTit div:nth-child(2) {
  font-family: PingFang SC;
  font-size: 11px;
  font-weight: 400;
  text-align: left;
  color: rgba(0, 0, 0, 0.9);
}
.answerTxt {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 400;
  line-height: 30px;
  padding: 0 10px;
}
.taskSco {
  background-color: rgba(253, 247, 243, 1);
  border-radius: 8px;
  padding: 10px 15px;
  box-sizing: border-box;
  margin: 8px 0;
  width: 100%;
}
.taskScoTit {
  display: flex;
  justify-content: space-between;
  margin: 0 0 20px;
}
.taskScoTit div:nth-child(1) {
  color: rgba(0, 0, 0, 0.9);
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
}
.taskScoTit div:nth-child(2) {
  color: rgba(0, 0, 0, 0.6);
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: 400;
}
.taskScoCon {
  display: flex;
  justify-content: space-between;
}

.taskScoConTit {
  text-align: left;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 10px;
  color: rgba(0, 0, 0, 0.9);
  border-left: 5px rgba(242, 161, 75, 1) solid;
  padding-left: 5px;
}
.WorkCon {
  background-color: rgba(255, 255, 255, 0.9);
  padding: 8px;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: PingFang SC;
  font-size: 12px;
  line-height: 20px;
  font-weight: 400;
  flex: 1;
}
.WorkConSY {
  background-color: rgba(255, 255, 255, 0.9);
  padding: 8px;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: 400;
  flex: 1;
}
.WorkConSY div {
  margin-bottom: 8px;
}
.WorkConSY div:last-child {
  margin-bottom: 0;
}
.RootImgBlockSy {
  width: 300px;
  white-space: nowrap;
  overflow: hidden;
  font-size: 12px;
  text-overflow: ellipsis;
}
.termC {
  margin: 30px 0 45px;
  font-size: 18px;
  color: rgba(92, 80, 70, 1);
  display: flex;
  justify-content: space-between;
  font-weight: 600;
}
.termC > div > span {
  color: rgba(176, 123, 0, 1);
  border-bottom: 2px solid rgba(242, 228, 213, 1);
  padding: 3px 10px;
  margin: 0 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/components/report.vue